import { createContext } from 'react';

export const BrandingStoreContext = createContext(null);
